import { Component } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { ViewWillEnter } from '@ionic/angular';
import { UsabillaService } from '@panamax/app-state';

@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.page.html',
  styleUrls: ['./desktop.page.scss'],
})
export class DesktopPage implements ViewWillEnter {
  constructor(private usabilla: UsabillaService) {}

  ionViewWillEnter() {
    if (!Capacitor.isNativePlatform()) {
      this.usabilla.show();
    }
  }
}
